import { Text } from 'foundations-components/components/Text';
import UITab from 'UIComponents/nav/UITab';
import { jsx as _jsx } from "react/jsx-runtime";
const Tab = ({
  children,
  tabId,
  title,
  active,
  disabled,
  tooltip,
  onClick
}) => {
  return /*#__PURE__*/_jsx(UITab, {
    tabId: tabId,
    title: /*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      children: title
    }),
    active: active,
    disabled: disabled,
    onClick: onClick,
    tooltip: tooltip,
    children: children
  });
};
export default Tab;